import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

export abstract class StructurePaddingsBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.STRUCTURE_INTERNAL_INDENTS;
  }
}
